
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke131aRequest, Sgke131aResponse, Sgke131aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke131aService {

  /**
   * コンストラクタ
   * @param {Sgke131aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke131aService
   */
  constructor(
    public service: Sgke131aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE131A_入金突合明細初期表示API呼び出し
   * @param {Sgke131aRequest} request 
   * @returns {Observable<Sgke131aResponse>}
   * @memberof UsedSgke131aService
   */
  public doSgke131a(request: Sgke131aRequest): Observable<Sgke131aResponse> {
    return this.service.sgke131aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE131A');
          return throwError(err.message);
        })
      );
  }

}
